import React from 'react';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { InquiryForm } from '../components/InquiryForm';
import { PageHeader } from '../components/PageHeader';
export function Contact() {
  return <>
      <PageHeader eyebrow="Executive Inquiry" title="Board Appointments, Advisory Consultations & Speaking Engagements" intro="Inquiries from boards, nominating committees, executive search firms and conference organizers are welcome." data-id="element-283" data-mp="1qo1t4dbe3q3y" />

      <section className="bg-offwhite py-16 lg:py-24" data-id="element-284" data-mp="t24fat7yg8yc">
        <div className="mx-auto grid max-w-shell gap-12 px-6 lg:grid-cols-12 lg:gap-16 lg:px-8" data-id="element-285" data-mp="t3ffyk63t0l8">
          <div className="lg:col-span-5" data-id="element-286" data-mp="17rtmp66n5972">
            <h2 className="font-serif text-2xl leading-snug text-navy" data-id="element-287" data-mp="12z8ta5rncy42">
              Direct office contact
            </h2>
            <p className="mt-4 text-base leading-relaxed text-charcoal" data-id="element-288" data-mp="f966a42laicb">
              A full board biography, curriculum vitae and speaking one-sheet are
              available on request. Responses to board and advisory inquiries are
              typically issued within two business days.
            </p>

            <ul className="mt-9 flex flex-col gap-4 border-t border-mist pt-8" data-id="element-289" data-mp="19fh78a7xjao1">
              <li className="flex items-center gap-3 text-sm text-charcoal" data-id="element-290" data-mp="1e8s3xij12b28">
                <MailIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-291" data-mp="1j7d5pmdxh2ss" />
                <a href="mailto:office@bluewaterstrategies.com" className="font-medium text-navy underline-offset-4 hover:underline" data-id="element-292" data-mp="mgkpmoqzvar0">
                  office@bluewaterstrategies.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-charcoal" data-id="element-293" data-mp="vfy27qaf0ffy">
                <PhoneIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-294" data-mp="10h5arrkdtino" />
                <a href="tel:+14055550142" className="font-medium text-navy underline-offset-4 hover:underline" data-id="element-295" data-mp="26vcw2l7bur6u">
                  (405) 555-0142
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-charcoal" data-id="element-296" data-mp="1m9gc8rtg4qyv">
                <MapPinIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-297" data-mp="1h7ha1l9g003i" />
                Oklahoma City, Oklahoma &middot; Washington, D.C.
              </li>
            </ul>
          </div>

          <div className="lg:col-span-7" data-id="element-298" data-mp="1r6zpboeeqxp8">
            <InquiryForm data-id="element-299" data-mp="13gvnnmks580v" />
          </div>
        </div>
      </section>
    </>;
}